













import Vue, { PropType } from 'vue';

import RoleSelectorPills from '@/components/RoleSelectorPills.vue';
import { orgRoleColors } from '@/components/utils/unrulrColors';
import { OrgUser } from '@/models/orgStructure';
import { OrgRole } from '@/models';

/// Handles the membership roles in the ORGANIZATION.
//  There are currently two options: `is_teacher` and `is_admin`
export default Vue.extend({
  components: {
    RoleSelectorPills
  },

  props: {
    membership: Object as PropType<OrgUser>,
    status: Number, // Well, an enum
    showRoleSelector: {
      type: Boolean,
      default: true
    },
    pillsBelow: {
      type: Boolean,
      default: false
    },
    slotInline: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isAdmin: this.membership.isAdmin,
      isOrganizer: this.membership.isOrganizer,
      pillsConfig: [
        {
          role: OrgRole.ADMIN,
          roleName: 'ADMIN',
          activeClasses: orgRoleColors.admin
        },
        {
          role: OrgRole.ORGANIZER,
          roleName: 'ORGANIZER',
          activeClasses: orgRoleColors.organizer
        },
        {
          role: OrgRole.MEMBER,
          roleName: 'MEMBER',
          activeClasses: orgRoleColors.member
        }
      ]
    };
  },

  computed: {
    isCreator(): boolean {
      return !this.isAdmin && !this.isOrganizer;
    },
    roles(): string[] {
      return [
        ...(this.isAdmin ? [OrgRole.ADMIN.toString()] : []),
        ...(this.isOrganizer ? [OrgRole.ORGANIZER.toString()] : []),
        ...(this.isCreator ? [OrgRole.MEMBER.toString()] : [])
      ];
    },
    isDirty(): boolean {
      return (
        this.isAdmin !== this.membership.isAdmin ||
        this.isOrganizer !== this.membership.isOrganizer
      );
    },
    dirtyMembership(): OrgUser {
      return {
        ...this.membership,
        isAdmin: this.isAdmin,
        isOrganizer: this.isOrganizer
      };
    },
    topLevelClasses(): string[] {
      return this.pillsBelow
        ? ['d-flex', 'flex-column']
        : ['d-flex', 'justify-space-between', 'flex-wrap', 'flex-sm-nowrap'];
    },
    controlsClasses(): string[] {
      const alignmentClasses = this.slotInline
        ? ['d-flex', 'align-center', 'justify-center', 'mx-2']
        : ['d-flex', 'flex-column', 'align-center', 'justify-center', 'mx-2'];

      const verticalMargin = this.pillsBelow ? 'my-2' : 'my-2';

      return [...alignmentClasses, verticalMargin];
    }
  },

  methods: {
    handleRoleChange(role: OrgRole) {
      switch (role) {
        case OrgRole.ADMIN:
          this.isAdmin = true;
          this.isOrganizer = false;
          break;
        case OrgRole.ORGANIZER:
          this.isOrganizer = true;
          this.isAdmin = false;
          break;
        case OrgRole.MEMBER:
          this.isAdmin = false;
          this.isOrganizer = false;
          break;
      }
    }
  }
});
